import { render, staticRenderFns } from "./customers_dropdown.vue?vue&type=template&id=a6a7defc&scoped=true&"
import script from "./customers_dropdown.vue?vue&type=script&lang=js&"
export * from "./customers_dropdown.vue?vue&type=script&lang=js&"
import style0 from "./customers_dropdown.vue?vue&type=style&index=0&id=a6a7defc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a7defc",
  null
  
)

export default component.exports